import { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [lamellesPos, setLamellesPos] = useState([50, 50, 50]);
  const [formDatas, setFormDatas] = useState({value: 'none'});
  const [uri, setUri] = useState(null);
  const [status, setStatus] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [possibilites, setPossibilites] = useState([13310, 13440, 13570]);
  
  // Function to handle window resizing
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const randomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min);
  };
  
  const val = randomInt(0, 2);

  const animationLoose = () => {
    let newPos = [...lamellesPos];
    
    // Check if screen is smaller than 480px
    if (windowWidth < 480) {
      newPos[0] = 13470;
      newPos[1] = 13350;
      newPos[2] = 13580;
    } else {
      newPos[0] = possibilites[val];
      newPos[1] = possibilites[val === 2 ? 0 : val + 1];
      newPos[2] = possibilites[val === 0 ? 2 : val - 1];
    }
    
    setLamellesPos(newPos);
  };

  const animationSac = () => {
    let newPos = [...lamellesPos];
    // Use different position values based on screen width
    const posValue = windowWidth < 480 ? 13470 : 13570;
    
    newPos[0] = posValue; 
    newPos[1] = posValue;
    newPos[2] = posValue;
    setLamellesPos(newPos);
  };

  const animationKeygen = () => {
    let newPos = [...lamellesPos];
    // Use different position values based on screen width
    const posValue = windowWidth < 480 ? 13350 : 13440;
    
    newPos[0] = posValue;
    newPos[1] = posValue;
    newPos[2] = posValue;
    setLamellesPos(newPos);
  };

  const send = async () => {
    const formData = new FormData();
    formData.append("input[game_id]", "b506368e-3d41-437a-bab2-d36d1cf0d760");
    formData.append("input[lang]", "en");
  
    // Add dynamic data
    for (let key in formDatas) {
      formData.append(`input[player_data][${key}]`, formDatas[key]);
    }
  
    try {
      let response = await fetch("https://api-gain.web-treeosk.online/play", {
        method: "POST",
        body: formData,
      });
  
      let responseData = await response.json();
      console.log(responseData);
  
      if (responseData.data && responseData.data.id) {
        switch (responseData.data.id) {
          case "d3fea9a5-41a5-4a93-9965-8e43bdd26c52":
            animationKeygen();
            break;
          case '70fe4599-2293-4b65-a8ea-c0f5c54bcb11':
            animationSac();
            break;
          case '749b65c7-605c-45bf-87c2-fbfc13650e15':
            animationLoose();
            break;
          default:
            break;  
        }
        setTimeout(() => {
          setUri(responseData.data.uri);
        }, 10000);
      }
    } catch (error) {
      console.error("Error during request:", error);
    }
  };

  const start = () => {
    setStatus(true);
    const audio = new Audio('./assets/son.mp3');
    audio.playbackRate = 1.5;
    
    setTimeout(() => {
      audio.play();
      send();
    }, 100);
  };

  return (
    <div className="App">
      {/* Fixed size container with proper centering */}
      <div className="game-wrapper">
        <div className="box-background"></div>
        
        <div className="lamelles-window">
          {/* Each lamelle has a fixed width and keeps its position */}
          <div className="lamelle-wrapper">
            <div 
              className="lamelle" 
              style={{ 
                backgroundPositionY: `${lamellesPos[0]}%`, 
                transitionDuration: '7s' 
              }}
            ></div>
          </div>
          
          <div className="lamelle-wrapper">
            <div 
              className="lamelle" 
              style={{ 
                backgroundPositionY: `${lamellesPos[1]}%`, 
                transitionDuration: '8s' 
              }}
            ></div>
          </div>
          
          <div className="lamelle-wrapper">
            <div 
              className="lamelle" 
              style={{ 
                backgroundPositionY: `${lamellesPos[2]}%`, 
                transitionDuration: '9s' 
              }}
            ></div>
          </div>
        </div>
        
        {uri && (
          <div className="gain-overlay">
            <img src={uri} alt='gain' className="gain-image" />
          </div>
        )}
        
        {!status && (
          <button onClick={start} className="play-button">
            CLICK HERE TO PLAY
          </button>
        )}
      </div>
    </div>
  );
}

export default App;